<template>
    <section class="section section-lg bg-default">
        <div class="container container-wide">
            <b-alert :show="!this.isEmpty(this.paramError)" variant="danger" dismissible fade ><div v-html="this.paramErrors[this.paramError] || this.paramErrors['default']"></div></b-alert>
            <b-alert :show="promotionApplied && couponId !== ''" variant="danger">
                注意！ クーポンはまだ適用されていません。<br>「利用規約に同意する」にチェックを入れた上で、「クーポンを利用する」を押して手続きを進めてください。
            </b-alert>
            <div class="row row-fix row-50 justify-content-lg-center">
                <div class="col-lg-11 col-xl-10 col-xxl-8">
                    <div class="tabs-custom tabs-horizontal tabs-line text-center" id="tabs-1">
                        <!-- Nav tabs-->
                        <ul class="instruction-placeholder">
                            <li class="nav-item">
                                <span class="intruction-text">ご希望のコース（サブスクリプション）と金額をご確認ください。</span>
                            </li>
                        </ul>
                        <div v-if="pageLoadingIndicator" class="page-loading-indicator">
                            <img src="/images/eowp/animation/loading-spinner.jpg" />
                        </div>
                        <!-- Tab panes-->
                        <div class="tab-content" v-else>
                            <div class="tab-pane fade show active" id="tabs-1-2">
                                <div class="table-checkout text-left">
                                    <div class="table-novi table-custom-responsive purchase-details-standard">
                                        <table class="table-custom">
                                            <tbody>
                                                <tr class="content-row">
                                                    <td
                                                        v-html="this.eowp.product.name + (this.eowp.product.firstMonth ? this.instructions.nextCharge : '')">
                                                    </td>
                                                    <td>
                                                        <!-- if promotionApplied and there is a difference between basePrice and oldBasePrice, show discount math-->
                                                        <span
                                                            v-if="promotionApplied & this.eowp.product.basePrice != this.oldBasePrice"
                                                            class="oldPrice">{{formatPrice(this.oldBasePrice)}}円</span>
                                                        <!--End discount math-->
                                                        <span class="discountedPrice">{{this.eowp.product.firstMonth ? 0 :
                                                        formatPrice(this.eowp.product.basePrice)}}円</span>
                                                    </td>
                                                </tr>
                                                <tr class="content-row">
                                                    <td>消費税 ({{this.eowp.product.taxRate}}%)</td>
                                                    <td>
                                                        <span
                                                            v-if="promotionApplied && this.eowp.product.tax != this.oldTax && !this.eowp.product.firstMonth"
                                                            class="oldPrice  tax">{{formatPrice(this.oldTax)}}円</span>
                                                            <span class="discountedPrice">{{this.eowp.product.firstMonth ? 0 :
                                                            formatPrice(this.eowp.product.tax)}}円</span>
                                                    </td>
                                                </tr>
                                                <tr class="content-row">
                                                    <td>本日（<strong>{{todaysDate}}</strong>）のお支払い額</td>
                                                    <td>
                                                        <span class="discountContainer">
                                                            <!-- if promotionApplied and there is a difference between totalPrice and oldTotalPrice, show discount math-->
                                                            <span
                                                                v-if="promotionApplied & this.eowp.product.totalPrice != this.oldTotalPrice"
                                                                class="oldPrice">{{formatPrice(this.oldTotalPrice)}}円</span>
                                                            <span
                                                                v-if="promotionApplied & this.eowp.product.totalPrice != this.oldTotalPrice"
                                                                class="discount"><img class="discountImage"
                                                                    src="/images/eowp/svg/discount.svg"> -{{discount}}
                                                            </span>
                                                            <!--End discount math-->
                                                            <span class="discountedPrice">
                                                                {{formatPrice(this.eowp.product.totalPrice)}}円
                                                            </span>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <!--If promotionApplied returns a coupon with a repeating (!= 'once') duration, add a row to the table-->
                                                <!--This new row shows how long the promotionApplied will give the user a discount-->
                                                <tr class="content-row"
                                                    v-if="(promotionApplied && this.eowp.product.firstMonth) || (promotionApplied && this.duration != 'once')">
                                                    <!-- Trialing or Returning (anyone besides Upgrading) users will see a new row, with the date that their discount begins, which is calculated based on todays date-->
                                                    <td v-if="currentPurchaseStatus == purchaseStatuses.trial || currentPurchaseStatus == purchaseStatuses.repurchase || (promotionApplied && this.couponId != '')">
                                                        <strong>
                                                            <span v-if="currentPurchaseStatus == purchaseStatuses.trial || currentPurchaseStatus == purchaseStatuses.upgrade">{{ discountStartDate }}</span>
                                                            <span v-else>{{ startDatePlusOneMonth }}</span>
                                                            <!-- For Duration=Forever, don't show duration count -->
                                                            <span
                                                                v-if="this.duration != 'forever' && (this.durationInMonths > 2 || (this.durationInMonths == 2 && this.eowp.product.firstMonth))">〜
                                                                {{this.eowp.product.firstMonth? this.durationInMonths :
                                                                this.durationInMonths - 1}}回</span>
                                                        </strong>
                                                        のお支払い額
                                                        <!-- For Duration=Forever, always show auto-renewal text -->
                                                        <span
                                                            v-if="this.duration == 'forever' || this.durationInMonths > 2 || (this.durationInMonths == 2 && this.eowp.product.firstMonth)">（自動更新）</span>
                                                    </td>
                                                    <!-- Upgrading users will see a new row, with the date that their current period ends-->
                                                    <td
                                                        v-if="currentPurchaseStatus == purchaseStatuses.upgrade && this.couponId == ''">
                                                        <strong>{{ this.eowp.subscriptionInfo.currentPeriodEnd }}</strong>
                                                        のお支払い額（年額：自動更新）
                                                    </td>
                                                    <td>
                                                        <span v-if="this.eowp.product.firstMonth"
                                                            class="discountContainer">
                                                            <span
                                                                v-if="promotionApplied & this.eowp.product.merchantPrice != this.oldMerchantPrice"
                                                                class="oldPrice">{{formatPrice(this.oldMerchantPrice)}}円</span>
                                                            <span
                                                                v-if="promotionApplied & this.eowp.product.merchantPrice != this.oldMerchantPrice"
                                                                class="discount"><img class="discountImage"
                                                                    src="/images/eowp/svg/discount.svg"> -{{discount}}
                                                            </span>
                                                            <span class="discountedPrice">
                                                                {{formatPrice(this.eowp.product.merchantPrice)}}円
                                                                （税込）／{{this.nextBillingUnit()}}
                                                            </span>
                                                        </span>
                                                        <span v-else>
                                                            {{formatPrice(this.eowp.product.merchantPrice)}}円
                                                            （税込）／{{this.nextBillingUnit()}}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <!-- This is the existing merchantPrice row, when there is a promotionApplied: this row should reflect the eventual price after all discounts conclude -->
                                                <!-- For Duration=Forever, don't show the "end date" row since discount continues indefinitely -->
                                                <tr class="content-row" v-if="promotionApplied && this.duration != 'forever'">
                                                    <td
                                                        v-if="currentPurchaseStatus == purchaseStatuses.trial || currentPurchaseStatus == purchaseStatuses.repurchase || (promotionApplied && this.couponId != '')">
                                                        <strong>{{ discountEndDate }}</strong>
                                                        以降のお支払い額（自動更新）
                                                    </td>
                                                    <td v-if="currentPurchaseStatus == purchaseStatuses.upgrade && this.couponId == ''">
                                                        <strong>{{ discountEndDate }}</strong>
                                                        以降のお支払い額
                                                    </td>
                                                    <td>
                                                        {{formatPrice(this.oldMerchantPrice)}}円（税込）／
                                                        {{this.nextBillingUnit()}}
                                                    </td>
                                                </tr>
                                                <!-- This is the existing merchantPrice row, when there is no promotionApplied -->
                                                <tr class="content-row" v-else>
                                                    <td v-if="currentPurchaseStatus == purchaseStatuses.repurchase">
                                                        次回以降のお支払い額（自動更新）
                                                    </td>
                                                    <td v-if="currentPurchaseStatus == purchaseStatuses.trial">
                                                        <strong>{{this.eowp.nextBillingDate}}</strong> 以降のお支払い額（自動更新）
                                                    </td>
                                                    <td v-if="currentPurchaseStatus == purchaseStatuses.upgrade">
                                                        <strong>{{this.eowp.subscriptionInfo.currentPeriodEnd}}</strong>
                                                        以降のお支払い額（年額：自動更新）
                                                    </td>
                                                    <td>
                                                        {{formatPrice(this.eowp.product.merchantPrice)}}円（税込）／
                                                        {{this.nextBillingUnit()}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!--MOBILE VERSION ---------------------->
                                    <div class="table-novi table-custom-responsive purchase-details-small">
                                        <table class="table-custom table-custom-bordered">
                                            <tbody>
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">{{this.eowp.product.name}}</span>
                                                            <span class="row-text"
                                                                v-html="this.eowp.product.firstMonth ? this.instructions.nextCharge : ''"></span>
                                                        </div>
                                                        <div class="mobile-div-text-right">
                                                            <!-- if promotionApplied and there is a difference between basePrice and oldBasePrice, show discount math-->
                                                            <span
                                                                v-if="promotionApplied & this.eowp.product.basePrice != this.oldBasePrice"
                                                                class="oldPrice">{{formatPrice(this.oldBasePrice)}}円</span>
                                                            <!--End discount math-->
                                                            <span class="row-text discountedPrice">{{this.eowp.product.firstMonth ? 0 :
                                                                formatPrice(this.eowp.product.basePrice)}}円</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span class="purchase-left-text">消費税
                                                                ({{this.eowp.product.taxRate}}%)</span>
                                                        </div>
                                                        <div class="mobile-div-text-right">
                                                            <span
                                                                v-if="promotionApplied && this.eowp.product.tax != this.oldTax && !this.eowp.product.firstMonth"
                                                                class="oldPrice tax">{{formatPrice(this.oldTax)}}円</span>
                                                                <span class="discountedPrice">{{this.eowp.product.firstMonth ? 0 :
                                                                formatPrice(this.eowp.product.tax)}}円&nbsp;</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span
                                                                class="purchase-left-text">本日（<strong>{{todaysDate}}</strong>）のお支払い額</span>
                                                        </div>
                                                        <div class="mobile-div-text-right">
                                                            <span class="discountContainer">
                                                                <!-- if promotionApplied and there is a difference between totalPrice and oldTotalPrice, show discount math-->
                                                                <span
                                                                    v-if="promotionApplied & this.eowp.product.totalPrice != this.oldTotalPrice"
                                                                    class="oldPrice">{{formatPrice(this.oldTotalPrice)}}円</span>
                                                                <span
                                                                    v-if="promotionApplied & this.eowp.product.totalPrice != this.oldTotalPrice"
                                                                    class="discount"><img class="discountImage"
                                                                        src="/images/eowp/svg/discount.svg">
                                                                    -{{discount}} </span>
                                                                <!--End discount math-->
                                                                <span
                                                                    class="purchase-right-text discountedPrice">{{formatPrice(this.eowp.product.totalPrice)}}円</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!--If promotionApplied returns a coupon with a repeating (!= 'once') duration, add a row to the table-->
                                                <!--This new row shows how long the promotionApplied will give the user a discount-->
                                                <tr class="content-row" v-if="(promotionApplied && this.eowp.product.firstMonth) || (promotionApplied && this.duration != 'once')">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <!-- Trialing or Returning (anyone besides Upgrading) users will see a new row, with the date that their discount begins, which is calculated based on todays date-->
                                                            <span class="purchase-left-text"
                                                                v-if="currentPurchaseStatus == purchaseStatuses.trial || currentPurchaseStatus == purchaseStatuses.repurchase || (promotionApplied && this.couponId != '')">
                                                                <strong>
                                                                    <span v-if="currentPurchaseStatus == purchaseStatuses.trial || currentPurchaseStatus == purchaseStatuses.upgrade">{{ discountStartDate }}</span>
                                                                    <span v-else>{{ startDatePlusOneMonth }}</span>
                                                                    <!-- For Duration=Forever, don't show duration count -->
                                                                    <span v-if="this.duration != 'forever' && (this.durationInMonths > 2 || (this.durationInMonths == 2 && this.eowp.product.firstMonth))">〜
                                                                        {{ this.eowp.product.firstMonth ? this.durationInMonths : this.durationInMonths - 1}}回</span>
                                                                </strong>
                                                                のお支払い額
                                                                <!-- For Duration=Forever, always show auto-renewal text -->
                                                                <span v-if="this.duration == 'forever' || this.durationInMonths > 2 || (this.durationInMonths == 2 && this.eowp.product.firstMonth)">（自動更新）</span>
                                                            </span>
                                                            <!-- Upgrading users will see a new row, with the date that their current period ends-->
                                                            <span class="purchase-left-text"
                                                                v-if="currentPurchaseStatus == purchaseStatuses.upgrade && this.couponId == ''">
                                                                <strong>{{this.eowp.subscriptionInfo.currentPeriodEnd}}</strong>
                                                                のお支払い額（年額：自動更新）
                                                            </span>
                                                        </div>
                                                        <div class="mobile-div-text-right">
                                                            <span v-if="this.eowp.product.firstMonth"
                                                                class="discountContainer">
                                                                <span
                                                                    v-if="promotionApplied & this.eowp.product.merchantPrice != this.oldMerchantPrice"
                                                                    class="oldPrice">{{formatPrice(this.oldMerchantPrice)}}円</span>
                                                                <span
                                                                    v-if="promotionApplied & this.eowp.product.merchantPrice != this.oldMerchantPrice"
                                                                    class="discount"><img class="discountImage"
                                                                        src="/images/eowp/svg/discount.svg">
                                                                    -{{discount}}
                                                                </span>
                                                                <span class="discountedPrice">
                                                                    {{formatPrice(this.eowp.product.merchantPrice)}}円<br>
                                                                    （税込）／{{this.nextBillingUnit()}}
                                                                </span>
                                                            </span>
                                                            <span v-else>
                                                                {{formatPrice(this.eowp.product.merchantPrice)}}円
                                                                （税込）／{{this.nextBillingUnit()}}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!-- This is the existing merchantPrice row, when there is a promotionApplied: this row should reflect the eventual price after all discounts conclude -->
                                                <!-- For Duration=Forever, don't show the "end date" row since discount continues indefinitely -->
                                                <tr class="content-row" v-if="promotionApplied && this.duration != 'forever'">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span
                                                                v-if="currentPurchaseStatus == purchaseStatuses.trial || currentPurchaseStatus == purchaseStatuses.repurchase || (promotionApplied && this.couponId != '')"
                                                                class="purchase-left-text"><strong>{{discountEndDate
                                                                    }}</strong>
                                                                以降のお支払い額（自動更新）
                                                            </span>
                                                            <span
                                                                v-if="currentPurchaseStatus == purchaseStatuses.upgrade && this.couponId == ''"
                                                                class="purchase-left-text"><strong>{{discountEndDate
                                                                    }}</strong>
                                                                以降のお支払い額
                                                            </span>
                                                        </div>
                                                        <div class="mobile-div-text-right">
                                                            <span
                                                                class="purchase-right-text">{{formatPrice(this.oldMerchantPrice)}}円（税込）／
                                                                {{this.nextBillingUnit()}}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!-- This is the existing merchantPrice row, when there is no promotionApplied -->
                                                <tr class="content-row" v-else>
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span
                                                                v-if="currentPurchaseStatus == purchaseStatuses.repurchase"
                                                                class="purchase-left-text">次回以降のお支払い額（自動更新）
                                                            </span>
                                                            <span v-if="currentPurchaseStatus == purchaseStatuses.trial"
                                                                class="purchase-left-text"><strong>{{this.eowp.nextBillingDate}}</strong>
                                                                以降のお支払い額（自動更新）
                                                            </span>
                                                            <span
                                                                v-if="currentPurchaseStatus == purchaseStatuses.upgrade"
                                                                class="purchase-left-text"><strong>{{this.eowp.subscriptionInfo.currentPeriodEnd}}</strong>
                                                                以降のお支払い額（年額：自動更新）
                                                            </span>
                                                        </div>
                                                        <div class="mobile-div-text-right">
                                                            <span
                                                                class="purchase-right-text">{{formatPrice(this.eowp.product.merchantPrice)}}円（税込）／
                                                                {{this.nextBillingUnit()}}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- END MOBILE VERSION ------------------>

                                    <div class="input-wrapper" v-if="!promotionApplied">
                                        <p class="promoCodeExplanationMessage">{{ promoCodeExplanationMessage }}</p>
                                        <input type="text" ref="promoCode" id="promoCodeField"
                                            @keypress="applyPromotionOnEnter" v-model="inputValue"
                                            @input="validateInput" placeholder="クーポンコードを入力" />
                                        <a class="input-button button-primary promoCodeButton" id="promoCodeButton"
                                            :class="disablePromoCodeButton('input-button')" @click="applyPromotion()"
                                            href="#">
                                            使用する
                                        </a>
                                        <div v-if="this.promoCodeWarningMessage != ''" class="warningMessage">
                                            {{ this.promoCodeWarningMessage }}
                                        </div>
                                    </div>
                                    <div class="successWrapper" v-if="this.promotionSuccessMessageTitle != ''">
                                        <b-alert :show="!this.isEmpty(this.promotionSuccessMessageTitle)"
                                            variant="success" fade>
                                            <div class="successContentsWrapper">
                                                <div class="imageMessageWrapper">
                                                    <img src="/images/eowp/svg/success.svg" class="alertImage">
                                                    <span class="successMessageWrapper">
                                                        <span
                                                            class="successTitle">{{this.promotionSuccessMessageTitle}}</span>
                                                        <span
                                                            class="successText">{{this.promotionSuccessMessageText}}</span>
                                                    </span>
                                                </div>
                                                <div class="successLine"></div>
                                                <a class="input-button button-primary closeAlertButton closeSuccessAlertButton"
                                                    v-if="promotionApplied && this.couponId == ''" id="promoCodeButton"
                                                    @click="restoreDefaultBasket()" href="#">使用停止</a>
                                            </div>
                                        </b-alert>
                                    </div>
                                    <b-alert :show="!this.isEmpty(this.promotionErrorMessage)" variant="danger" fade>
                                        <div class="errorAlertWrapper">
                                            <div class="imageMessageWrapper">
                                                <img src="/images/eowp/svg/error.svg" class="alertImage">
                                                <p class="errorMessage" v-html="this.promotionErrorMessage">
                                                </p>
                                            </div>
                                            <a class="input-button button-primary closeAlertButton closeErrorAlertButton"
                                                v-if="this.promotionErrorMessage != ''" id="promoCodeButton"
                                                @click="hidePromotionError()" href="#">
                                                閉じる
                                            </a>
                                        </div>
                                    </b-alert>
                                    <div class="form-wrap">
                                        <div>
                                            <span>サービスのご利用開始にあたり、 <a class="link"
                                                    @click="trackBasketPageHyperlinks('policy_link_click', 'https://www.alc.co.jp/policy/other/')">利用規約</a>
                                                の全文にご同意いただく必要があります。</span>
                                        </div>
                                        <ul class="radio-group">
                                            <li>
                                                <label class="radio-inline agreed-checkbox">
                                                    <input type="checkbox" v-model="readAgreement"
                                                        name="radio-group" />&nbsp; 上記利用規約を読んだ上で、同意する
                                                </label>
                                            </li>
                                        </ul>
                                        <br>
                                        <ul class="instruction-placeholder">
                                            <li class="nav-item" v-if="this.eowp.product.firstMonth">
                                                <span class="intruction-text"
                                                    v-if="currentPurchaseStatus == purchaseStatuses.repurchase">※領収書の発行は、翌月の10日以降、ご自身でアカウントページからお願いいたします。</span>
                                                <span class="intruction-text"
                                                    v-if="currentPurchaseStatus == purchaseStatuses.trial">※領収書の発行は、<strong>{{this.eowp.nextBillingDate}}</strong>
                                                    の翌日以降、ご自身でアカウントページからお願いいたします。</span>
                                                <span class="intruction-text"
                                                    v-if="currentPurchaseStatus == purchaseStatuses.upgrade">※領収書の発行は、<strong>{{this.eowp.subscriptionInfo.currentPeriodEnd}}</strong>
                                                    の翌日以降、ご自身でアカウントページからお願いいたします。</span>
                                            </li>
                                            <li class="nav-item">
                                                <span class="intruction-text">※なお、解約をご希望の場合も、アカウントページからお手続きをお願いいたします。<div
                                                        class="annotation">《<a target="_blank"
                                                                href="/tokusho">特定商取引に関する法律に基づく表示</a>》
                                                    </div></span>
                                            </li>
                                            <li class="nav-item" v-if="promotionApplied && this.couponId != ''">
                                                <span class="intruction-text">※お支払いは、これまでご利用のクレジットカードで行われます。</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <form id="payment-portal" method="POST"
                                        :action="backendDomainUrl + '/payment-portal'" ref="paymentPortalForm">
                                        <input type="hidden" v-model="paymentParams.clientIp" name="clientip" />
                                        <input type="hidden" v-model="paymentParams.money" name="money" />
                                        <input type="hidden" v-model="paymentParams.telno" name="telno" />
                                        <input type="hidden" v-model="paymentParams.email" name="email" />
                                        <input type="hidden" v-model="paymentParams.sendPoint" name="sendpoint" />
                                        <input type="hidden" v-model="paymentParams.sessionId" name="sessionid" />
                                        <input type="hidden" v-model="paymentParams.userId" name="userid" />
                                    </form>
                                    <div class="form-buttons">
                                        <div v-if="loadingIndicator" class="loading-indicator">
                                            <img src="/images/eowp/animation/loading-spinner.jpg" />
                                        </div>
                                        <div v-else>
                                            <a class="button button-primary button-nina proceed-button"
                                                v-if="promotionApplied && this.couponId != ''"
                                                :class="disableElement('button')"
                                                @click="submitForm('coupon_applied_click')" href="#">
                                                クーポンを利用する
                                            </a>
                                            <a class="button button-primary button-nina proceed-button" v-else
                                                :class="disableElement('button')"
                                                @click="submitForm('proceed_to_payment_click')" href="#">
                                                お支払い（決済）に進む
                                            </a>
                                        </div>
                                        <a class="button button-primary button-nina back-button"
                                            v-if="promotionApplied && this.couponId != ''" href="/account">アカウントページへ戻る</a>
                                        <a @click="backButtonClicked()"
                                            class="button button-primary button-nina back-button" v-else
                                            href="#">コース選択に戻る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-div-text{
    position: relative;
    display: block;
    white-space: normal;
    text-align: left;
}
.mobile-div-text-right{
    position: relative;
    display: block;
    white-space: normal;
    text-align: right;
}
.purchase-details-small ul li{
    font-size: 11px;
    font-weight: 600;
}
.purchase-details-small ul li div span{
    margin-top: 11px;
}
.button-guide{
    position: relative;
    display: block;
    float: right;
    width: 100%!important;
    text-align: right!important;
    padding-top: 5px!important;
}
.button-guide ul{
    width: 300px!important;
    display: inline;
    right: 93px!important;
    position: relative;
    font-size: 11px;
}
.page-loading-indicator {
    text-align: center;
    position: relative;
    display: inline-flex;
    padding-top: 20px!important;
}
.page-loading-indicator > img {
    width: 50px;
}
.loading-indicator {
    text-align: center;
    position: relative;
    display: inline;
    float: right;
    width: 318px!important;
}
.loading-indicator > img {
    width: 50px;
    position: relative;
    margin-right: 15px!important;
}
.nav-item{
    padding-bottom: 5px!important;
}
.instruction-placeholder{
    text-align: left!important;
}
.intruction-text{
    cursor: default!important;
    font-size: 16px!important;
}
.annotation {
    display: inline-block;
}
.alert{
    margin-top: 10px!important;
}
.button-disabled{
    background-color: #dddddd!important;
    color: #bbbbbb!important;
    border-color: #dddddd!important;
    pointer-events: none;
    cursor: default;
}
.proceed-button{
    background-color: #961e23;
    color: #eeeeee;
    border-color: #961e23;
    cursor: pointer;
}
.back-button{
    background-color: transparent!important;
    color: #555555;
    border-color: #aaaaaa;
    cursor: pointer;
}
a.link{
    color: blue;
}
.section{
    padding-top: 60px!important;
    padding-bottom: 80px!important;
}
.button{
    position: relative!important;
    display: flex!important;
    float: right!important;
    margin-top: 0px!important;
    margin-right: 10px!important;
}
.form-buttons{
    padding-top: 30px;
}
.table-checkout{
    max-width: 1800px!important;
    width: auto!important;
    font-size:16px;
}

/*Price Modifications in Table */

.discountContainer{
    display:inline-flex;
    flex-direction:row;
    float:right;
    align-items: center;
}

.discountContainer #text{
    white-space: pre-line !important;
}

.discountImage{
    margin-right:5px;
}

.discount {
    display:flex;
    width: 90px;
    height: 30px;
    margin:0px 12px;
    border-radius: 4px;
    background: #4FB194;
    align-items: center;
    align-content:center;
    justify-content: center;
    white-space: nowrap;
    color:white;
    font-size:16px;
}

.discountedPrice{
    margin-left:12px;
    white-space: nowrap;
}

.tax{
    padding-right: 1ch;
}

.oldPrice{
    color:#949494;
    text-decoration: line-through;
    vertical-align: middle;
    width: fit-content;
    white-space: nowrap;
}

/*End Price Modifications in Table */
/*Input PromoCode stylings */

.input-wrapper{
    text-align: left;
    padding: 30px;
    max-width:100% !important;
    width:100% !important;
    align-items: center;
    border-bottom: 1px solid #ededed;
}

.promoCodeExplanationMessage {
    margin-top: 0px;
    margin-bottom:5px;
    align-self: center;
    min-height: 26px;
    max-width:inherit;
}

#promoCodeField{
    width:200px;
    height:40px;
    padding:0px 20px;
    box-sizing: border-box;
    vertical-align: top !important;
    align-items: center;
    gap: 10px;
    border: 1px solid var(--D7D7D7, #D7D7D7);
    font-size:16px;
}
.input-button,
.input-button-disabled {
    border: solid 2px;
    border-spacing: 2px;
    padding: 2px 1px;
    display: inline-block;
}

.input-button-disabled {
    border-color: #dddddd !important;
    background-color: #ddd !important;
    color: #bbbbbb!important;
    pointer-events: none;
    cursor: default;
}

.promoCodeButton{
    position:relative;
    display:inline-block;
    vertical-align: top;
    line-height: 20px;
    text-align: center;
    height: 40px;
    width:104px;
    margin:0px 12px;
    padding: 10px 20px;
    align-items: center;
    border-radius: 4px;
    border:none;
    background: #0080DE;
    color:white;
    font-size:15px;
}

.warningMessage{
    background-image: url("/images/eowp/svg/warning-bg.svg");
    background-size:100% 100%;
    background-repeat: no-repeat;
    width: 275px;
    height: 40px;
    display:inline-flex;
    padding:10px 10px 10px 20px;
    font-size: 16px;
    color: #B8B032;
    vertical-align: middle;
    line-height:20px;
}

/*End Input PromoCode stylings */
/*PromoCode Applied stylings */

.successWrapper{
    border-bottom: 1px solid #ededed;
}

.alert-success,
.alert-danger {
    display:flex;
    border:none;
    padding:20px 24px;
    margin:20px 24px 20px 24px !important;
    line-height: 20px;
    justify-content: space-between;
}
.alert-success{
    background: rgba(79, 177, 148, 0.1) !important; /* Its easier to represent this in rgba than in hex, given the opacity of 10% */
    color: #4FB194!important;
}
.alert-danger{
    background-color: #ffdfdf!important;
    color: #843131 !important;
}

.successContentsWrapper{
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    justify-content: space-between;
    width:100%;
}

.imageMessageWrapper{
    display: inline-flex;
    align-items:center;
    align-self: start;
}

.alertImage{
    width:40px;
    height:40px;
    vertical-align: top;
}

.successMessageWrapper{
    display:flex;
    flex-direction: column;
}

.successMessageWrapper,
.errorMessage{
    margin-left:16px !important;
}

.successTitle,
.successText {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
}

.successTitle {
    color: var(--000000, #000);
    font-size: 16px;
}

.successText {
    color: var(--666666, #666);
    font-size: 14px;
}

.closeAlertButton{
    height:20px;
    float:right !important;
    background-color: inherit;
    border:none;
    text-align: right;
    padding:0px;
    vertical-align: middle;
}

.closeErrorAlertButton,
.closeSuccessAlertButton{
    line-height: 20px; /*Keeps the closure TEXT of the alert centered vertically */
    margin:auto 0px;
    text-wrap: nowrap;
}

.closeSuccessAlertButton{
    color: #4FB194!important;
}

.closeErrorAlertButton{
    color:#961e23 !important;
}

.errorAlertWrapper{
    display:inline-flex;
    align-items:center;
    width:100%;
    justify-content: space-between; /*This keeps each element spaced equally apart*/
}

.alert-danger{
    display:flex;
}
.alert-danger p{
    margin:0px;
    margin-right:auto; /*This overrides the equal spacing of each element in the errorAlertWrapper, so now the text will sit on the left side, together with the image, but stay separated away from the close button*/
}

/*End PromoCode Applied stylings */

.agreed-checkbox {
    padding-left: 0px !important;
}
.disabled{
    opacity: 0.5;
    margin-bottom: -200px;
}
@media screen and (max-width: 1100px){
    .table-checkout,
    #promoCodeField,
    .promoCodeButton,
    .warningMessage {
        font-size: 14px;
    }
    .discount,
    .successTitle,
    .successText{
        font-size: 13px;
    }
}

@media screen and (max-width: 675px){
    #promoCodeField,
    .promoCodeButton {
        font-size: 13px;
    }
    #promoCodeField {
        margin-bottom: 10px;
        padding-left: 20px;
    }
    .warningMessage{
        display: flex;
        justify-content: center;
        align-items: center;   
        background-image: url("/images/eowp/svg/warning-bg2.svg");
        background-size: contain;
        background-repeat: no-repeat;
        padding:15px 10px 10px 10px;
        width: 100%;
        max-width:318px;
        height: 48px;
        display:inline-flex;
        font-size:13px;
        vertical-align: baseline;
    }
}

@media screen and (max-width: 635px){
    .purchase-details-standard{
        display: none!important;
    }
    .purchase-details-small{
        display: block!important;
        padding-left: 5px!important;
        padding-right: 5px!important;
    }
    .form-wrap{
        margin-left: 7px!important;
        margin-right: 7px!important;
    }

    .alert-danger{
        display:flex;
        align-items: center;
        font-size:13px;
    }

    .alert-success,
    .alert-danger {
        padding:12px;
        margin:10px 0px 20px 0px !important;
    }

    .successWrapper{
        border-bottom: 1px solid #ededed;
    }

    .successContentsWrapper,
    .successWrapper{
        display:flex;
        flex-direction: column;
    }

    .imageMessageWrapper{
        display: inline-flex;
    }
    .successLine{
        width:100%;
        align-self: center;
        border-bottom: 1px solid rgba(79, 177, 148, 0.1) ; /*#4FB194 with an opacity of 10%*/
        margin-top:10px;
    }

    .alertImage{
        width:24px;
        height:24px;
    }

    .successMessageWrapper{
        display:flex;
        flex-direction: column;
        margin-left:16px;
    }

    .successText,
    .successTitle{
        font-family: Roboto;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }

    .successTitle{
        color: var(--000000, #000);
    }

    .successText{
        color: var(--666666, #666);
    }
    .closeAlertButton{
        padding: 0px;
        margin: 10px 10px 0px 10px;
        background-color: inherit;
        border:none;
        text-align: center;
        vertical-align: middle;
    }
    .closeErrorAlertButton,
    .closeSuccessAlertButton{
        position:static;
        transform:none;
    }
    .closeErrorAlertButton{
        margin:0;
    }
    .alert-danger p{
        margin-right:5px;
    }
}

@media screen and (max-width: 539px){
    .button{
        position: relative!important;
        display: block!important;
        margin-top: 0px!important;
        float: none!important;
        margin-bottom: 12px!important;
    }
    .button-guide{
        display: none!important;
    }
    .loading-indicator{
        width: 100%!important;
        padding-bottom: 10px!important;
    }
    .loading-indicator > img {
        width: 40px;
        margin-right: 5px!important;
    }
    .promoCodeButton{
        margin-bottom:10px;
    }
}

@media screen and (max-width: 408px){
    #promoCodeField{
        margin-right:12px;
        width:160px;
        font-size: 12px;
    }
    .promoCodeButton{
        width:auto;
        padding:10px !important;
        margin:0px;
        margin-bottom:10px;
    }
    .warningMessage{
        width: 265px; /*Bigger than we would like but it fits the new text */
        aspect-ratio: 350 / 48;
        min-height: 48px;
        padding:10px;
        font-size:13px;
    }
}

@media screen and (max-width: 383px){
    .promoCodeButton{
        margin:0px;
        margin-bottom:10px;
    }
}

@media screen and (min-width: 636px){
    .purchase-details-standard{
        display: block!important;
    }
    .purchase-details-small{
        display: none!important;
    }
}
@media screen and (max-width: 991px){
    .section{
        padding-top:35px !important;
    }
    .table-custom-responsive > .table-custom > thead > tr > th,
	.table-custom-responsive > .table-custom > thead > tr > td,
	.table-custom-responsive > .table-custom > tbody > tr > th,
	.table-custom-responsive > .table-custom > tbody > tr > td,
	.table-custom-responsive > .table-custom > tfoot > tr > th,
	.table-custom-responsive > .table-custom > tfoot > tr > td {
		white-space:wrap;
	}
    .table-checkout{
        font-size:13px;
    }
    .input-wrapper{
        padding:20px;
    }
    .discount {
        width: 76px;
        height: 28px;
    }
    .discountImage{
        height:16px;
        width:16px;
    }
}

@media screen and (max-width: 991px) and (min-width: 509px){
    .button-guide ul{
        right: 68px!important;
    }
}

@media screen and (max-width: 991px) and (min-width: 540px){
    .loading-indicator{
        width: 285px!important;
    }
}
</style>

<script>
import { BAlert } from "bootstrap-vue";
import { mapActions, mapGetters } from 'vuex';
import CouponManager from '../../js/helpers/CouponManager';
import DialogMixin from '../../js/helpers/mixins/DialogMixin';
import PageControl from '../../js/helpers/PageControl';
import Utils from '../../js/helpers/Utils';
import BaseModel from '../../js/models/BaseModel';
import ShopConstants from '../../js/helpers/ShopConstants';

export default {
    data(){
        return {
            paymentParams: {
                clientIp: '',
                money: '',
                telno: '', //Fine to leave this blank, user will fill this in on zeus page
                email: '',
                sendPoint: 'FIRST_ACTIVATE',
                sessionId: '',
                userId: ''
            },
            eowp: {
                product: {
                    itemId: '',
                    itemType: '',
                    name: "EOWP",
                    firstMonth: true,
                    taxRate: 0,
                    tax: 0,
                    basePrice: 0,
                    totalPrice: 0,
                    merchantPrice: 0,
                    previousSubscriptions: false,
                    previousSubscriptionRecords: [],
                    allSubscriptionRecords: []
                },
                itemTypes: {
                    EOWP_MONTHLY_ITEM: 'MONTHLY',
                    EOWP_YEARLY_ITEM: 'YEARLY'
                },
                yearlyItemTypes: {
                    EOWP_YEARLY_ITEM: 'YEARLY',
                    EOWP_YEARLY_S_ITEM: 'YEARLY',
                },
                PAYMENT_FAILURE: '2',
                nextBillingDate: '',
                subscriptionInfo: {
                    currentPeriodEnd: '',
                },
                infoRequestType: {
                    REQUEST_TYPE_SUBSCRIPTION_ID: 5
                }
            },
            userId: '',
            hasKakinRecord: false,
            readAgreement: false,
            backendDomainUrl: '',
            paramError: '',
            paramErrors: {
                '1': '送信パラメーターの不足が検出されました。お手数ですが一旦ログアウトし、再度ログインしてからお試しください。',
                '2': 'セッションのエラーまたは期限切れが検出されました。お手数ですが一旦ログアウトし、再度ログインしてからお試しください。',
                '3': 'セッション中のメールアドレスの不整合が検出されました。お手数ですが一旦ログアウトし、再度ログインしてからお試しください。',
                '4': '処理中にエラーが発生しました。お手数ですが再度お試しください。問題が解消しない場合は、お問い合わせください。',
                '5': 'ペイメントゲートウェイの初期化中にエラーが発生しました。もう一度お試しください。', //'An error has occurred while initializing payment gateway. Please try again'
                '6': '通信障害により処理の完了を確認できませんでした。恐れ入りますが、<a href="#" onclick="location.reload(); return false;">こちらをクリックしてページを再読み込み</a>のうえ、再度お試しください。解決しない場合はお手数ですが、<a target="_blank" href="' + ShopConstants.CONTACT_FORM_LINK + '">英辞郎 on the WEB お問い合わせフォーム</a>からお問い合わせください。',
                'default': '通信障害により処理の完了を確認できませんでした。恐れ入りますが、再度お試しください。解決しない場合はお手数ですが、<a target="_blank" href="' + ShopConstants.CONTACT_FORM_LINK + '">英辞郎 on the WEB お問い合わせフォーム</a>からお問い合わせください。',
            },
            reasonInfo: {
                INFO_0: "有効なクーポンです。", // valid or eligible promotion / coupon
                //VALID = FALSE
                INFO_100: "このクーポンコードは無効です。（INFO_100）", // invalid: not existing promotion
                INFO_101: "このクーポンコードは無効です。（INFO_101）", // invalid: not valid coupon
                INFO_102: "このクーポンコードは無効です。（INFO_102）", // invalid: expired promotion
                INFO_103: "このクーポンコードは無効です。（INFO_103）",  // invalid: not live mode (coupon only for stg env.)
                INFO_104: "このクーポンコードは無効です。（INFO_104）",  // invalid: not active promotion
                // ELIGIBLE = FALSE
                INFO_110: "このクーポンは、初めてのご注文でのみ利用できる特典です。（INFO_110）",  // not eligible: this promotion / coupon is only for first_time_transaction
                INFO_111: "このクーポンは、{minimum_amount}円以上の定期購入でご利用ください。（INFO_111）", // not eligible: this promotion / coupon requires purchase above minimum_amount
                // INFO_112: "このクーポンコードは適用の上限数に達しました。（INFO_112） ", // not eligible: this promotion / coupon already reached max_redemptions //03/26 It is not possible to return this error code, because maxed out coupons, and maxed out promotions BOTH return Info 104, promoCode is invalid
                INFO_113: "このクーポンは、ご利用済みの特典です。（INFO_113）", // not eligible: this promotion has already been used once
                INFO_114: "このクーポンコードは、過去に使用されました。（INFO_114）", // not eligible: this coupon has already been used once within the cooldown
                INFO_115: "このクーポンは、「{eligible_courses}」でご利用ください。（INFO_115）", // not eligible: this promotion / coupon can't be used for this subscription's course
                //INFO_116: "このクーポンは、使用できません。（INFO_116）", // not eligible: user already has an ongoing subscription with a coupon applied //It is not intended that we return this error code on the basket page, only on the account page when routing user to offer page
                INFO_120: "このクーポンは、初めてのご利用の方にはご利用いただけません。（INFO_120）", // not eligible: this promotion / coupon cannot be used by first-time subscribers
            },
            pageLoadingIndicator: true,
            loadingIndicator: false,
            purchaseStatuses: {
                trial: 1,
                repurchase: 2,
                upgrade: 3,
            },
            currentPurchaseStatus: '',
            instructions: {
                notes: {
                    purchase: '&nbsp;初回お申し込み<strong>2週間無料</strong>',
                    upgrade: '&nbsp;本日のお支払額',
                },
                nextCharge: '',
            },
            inputValue: '',
            promoCode: '',
            couponId: '',
            promoCodeButtonDisabled: true,
            promoCodeExplanationMessage: 'クーポンコードをお持ちの場合は、ここに入力してください。',
            promotionApplied: false,
            promotionErrorMessage: '',
            promoCodeWarningMessage: '',
            promotionSuccessMessageTitle: '',
            promotionSuccessMessageText: '',
            discount: '0',
            oldBasePrice: 0,
            newBasePrice: 0,
            oldTotalPrice: 0,
            newTotalPrice: 0,
            oldTax: 0,
            newTax: 0,
            oldMerchantPrice: 0,
            newMerchantPrice: 0,
            duration: "once",
            durationInMonths: 1,
        };
    },
    async created(){
        this.pageLoadingIndicator = true;
        this.clearChangeCC();
        this.clearUpdateCCResult();
        this.clearReadAgreement();
        this.backendDomainUrl = BaseModel.getHost();
        let params = Utils.getParameters(window.location.href);
        if(params && params.error){
            this.paramError = params.error;
        }

        if(Utils.isEmpty(this.chosenItem) || Utils.isEmpty(this.sessionDetails)){
            this.$router.push("/products");
        }
        this.setPathIntention('/basket');
        this.eowp.product.itemId = this.chosenItem;
        this.userId = this.sessionDetails.userId;
        this.currentPurchaseStatus = this.purchaseStatus();

        this.instructions.nextCharge = (this.currentPurchaseStatus == this.purchaseStatuses.upgrade) ? this.instructions.notes.upgrade : this.instructions.notes.purchase;

        if(this.currentPurchaseStatus == this.purchaseStatuses.upgrade){
            await this.getInfo({requestId: 3, csOrderNo: this.currentSubscription.csOrderNo, format: 'yyyy/MM/dd'}).then(res => {
                this.eowp.subscriptionInfo.currentPeriodEnd = res.records;
            });
        }

        let productInfo = this.products.filter(obj => obj.csMatNo == this.eowp.product.itemId);
        if(productInfo.length > 0){
            this.eowp.product.itemType = this.eowp.itemTypes[productInfo[0].itemType];
        }

        await this.getPreviousItemSubscriptions({custId: this.userId}).then(res => { 
            if(res.records && res.records.length > 0){
                let filteredSubs = res.records.filter(obj => obj.useStatus == '0' || obj.useStatus == '2'); //we may include VALID_TO if it's expired or not - but not necessary
                this.eowp.product.allSubscriptionRecords = res.records;
                this.eowp.product.previousSubscriptions = (filteredSubs.length > 0) ? true : false;
                this.eowp.product.previousSubscriptionRecords = filteredSubs;
            }
        });

        await this.getActiveFreeMonthRecords(this.userId);
        await this.retrieveProduct(this.eowp.product.itemId).then(res => {
            if(!res.records) return;
            this.eowp.product.name = res.records.productName;
            this.eowp.product.firstMonth = ((res.records.firstMonthFree == "1" && !this.eowp.product.previousSubscriptions) || this.activeFreeMonthRecords.length || (res.records.firstMonthFree == "1" && this.savedCouponId != '')) ? true : false;
            this.eowp.product.taxRate = res.records.taxRate;
            this.eowp.product.tax = res.records.merchantProductPrice - res.records.productPrice;
            this.eowp.product.basePrice = res.records.productPrice;
            this.eowp.product.totalPrice = this.eowp.product.firstMonth ? 0 : res.records.merchantProductPrice;
            this.eowp.product.merchantPrice = res.records.merchantProductPrice;

            this.paymentParams.clientIp = res.records.clientIp;

            if(this.eowp.product.firstMonth){
                this.getInfo({requestId: 1, format: 'yyyy/MM/dd'}).then(res => {
                    this.eowp.nextBillingDate = res.records;
                });
            }
        });

        await this.retrieveOtherSubscription({custId: this.userId}).then(res => {
            let hasRecord = false;
            if(res && res.records && res.records.result){
                hasRecord = !hasRecord ? !Utils.isEmpty(res.records.result.chargeTypeDescription) : hasRecord;
                hasRecord = !hasRecord ? !Utils.isEmpty(res.records.result.expireDate) : hasRecord;
                hasRecord = !hasRecord ? (res.records.result.chargeType > 0) : hasRecord;
            }
            this.hasKakinRecord = hasRecord;
            this.eowp.product.totalPrice = this.eowp.product.firstMonth ? 0 : this.eowp.product.merchantPrice;
        });

        // If user has previous monthly/yearly subscriptions, then it should use REACTIVATE
        if(this.eowp.product.previousSubscriptionRecords.length > 0){
            this.paymentParams.sendPoint = 'REACTIVATE';
        }

        // If this is an upgrade from active monthly to yearly, then it should be FIRST_ACTIVATE
        if(this.eowp.product.allSubscriptionRecords.length > 0 && this.eowp.product.itemType == 'YEARLY'){
            let monthlyItem = this.products.filter(obj => obj.itemType == 'EOWP_MONTHLY_ITEM');
            let itemId = monthlyItem[0].csMatNo;
            let previousActiveMonthly = this.eowp.product.allSubscriptionRecords.filter(obj => obj.csMatNo == itemId && obj.useStatus == '1');
            if(previousActiveMonthly.length > 0){
                this.paymentParams.sendPoint = 'FIRST_ACTIVATE';
                // Logic #130 - For all active monthly subscribers switching to yearly subscription, it should start at zero price (free month activate)
                this.eowp.product.firstMonth = true;
                this.eowp.product.totalPrice = 0;
            }
        }

        // LOGIC #122: force to use FIRST_ACTIVATE for subscriber with current sub (annual EOWP/EOWP(S)) which is expired and use_status=2
        await this.getCurrentSubscription(this.sessionDetails.userId).then(async () => {
            if (Utils.isEmpty(this.currentSubscription) || this.currentSubscription.useStatus != this.eowp.PAYMENT_FAILURE) return;

            await this.retrieveProducts();
            let item = this.products.filter(obj => obj.csMatNo == this.currentSubscription.csMatNo);
            if (item.length <= 0) return;

            if (!Utils.isEmpty(this.eowp.yearlyItemTypes[item[0].itemType])) {
                await this.dateExpired({ custId: this.currentSubscription.custId, csOrderNo: this.currentSubscription.csOrderNo, compareTime: true }).then(res => {
                    if (res.records) {
                        this.paymentParams.sendPoint = 'FIRST_ACTIVATE';
                        this.eowp.product.firstMonth = false;
                        this.eowp.product.totalPrice = this.product.merchantProductPrice;
                    }
                });
            }
        });

        const now = new Date();
        const validTo = new Date(this.currentSubscription?.validTo);
        const isNotExpired = validTo.getTime() > now.getTime();

        var isNotAllowInBasketPage =
            this.currentSubscription?.useStatus == '0' && isNotExpired || // To be cancelled users
            this.currentSubscription?.useStatus == '1' && this.currentSubscription?.csMatNo === this.eowp.product?.itemId && this.savedCouponId == '' || // Active users trying to buy the already owned subscription
            this.currentSubscription?.useStatus == '2'  && isNotExpired || // Unpaid users
            this.currentSubscription?.useStatus == '3'; // Upgrade users (If a future offer will be available for upgrades fix this condition)

        if (isNotAllowInBasketPage) {
            console.warn("User is not allowed to stay in basket page");
            if (this.currentSubscription?.useStatus == '0' && isNotExpired) {
                this.$router.push({
                    path: '/account',
                    query: { error: encodeURIComponent(409) }
                });
            } else
                this.$router.push("/account");
        }

        this.paymentParams.userId = this.userId;
        this.paymentParams.sessionId = this.sessionDetails.sessionId;
        this.paymentParams.email = this.user;
        this.paymentParams.money = this.eowp.product.totalPrice;

        this.setItemCharge(this.product.merchantProductPrice);
        //Check if a promoCode or a couponId exists in state (promoCodes get set in state when 「使用」, and couponIds will get saved in state by the Offer page): if found, use them
        if (this.savedPromoCode != '' || this.savedCouponId != '') {
            await this.applyPromotion().then(() => {
                if (this.currentSubscription?.csMatNo === this.eowp.product?.itemId && this.savedCouponId == '' && 
                    !this.isSubscriptionExpired()) {  // If the subscription is expired, the user should be able to apply a coupon
                    console.warn("User is not allowed to stay in basket page");
                    this.$router.push("/account");
                }
            });
        }
        else {
            this.pageLoadingIndicator = false; //page has finished loading, so we can show content now. Included in "else" because applyPromotion shows content as its last step
        }

        this.logActivity({ type: "info", message: " Loaded Basket Page with userId: " + this.sessionDetails.userId + " and sessionId: " + this.sessionDetails.sessionId },
            + " with item price: " + this.eowp.product.firstMonth ? 0 : this.eowp.product.basePrice + ", tax of: " + this.eowp.product.firstMonth ? 0 : this.eowp.product.tax + " and total price: " + this.eowp.product.totalPrice);
    },
    watch: {
        readAgreement: function(value) {
            this.setReadAgreement(value);
        },
        sessionDetails: function(sessionValue) {
            new PageControl(this).validateSession(sessionValue);
        }
    },
    // When the user navigates away from Basket we decide what to do with pathIntention so that
    // pressing the browser Back button can still open /offer.
    beforeRouteLeave(to, from, next) {
        if (to.path === '/offer') {
            // Mark intent so Offer page guard lets the user in.
            this.setPathIntention('/offer');
        } else {
            // For any other destination we don't need the flag.
            this.setPathIntention('');
        }
        next();
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            chosenItem: 'ncs/chosen_item',
            product: 'ncs/product',
            products: 'ncs/products',
            productTypes: 'ncs/product_types',
            currentSubscription: 'ncs/current_subscription',
            activeFreeMonthRecords: 'ncs/active_free_month',
            sessionDetails: 'user/session_details',
            pathIntention: 'user/path_intention',
            savedPromoCode: 'coupon/promo_code',
            savedCouponId: 'coupon/coupon_id',
        }),
        freeMonth: function(){
            return this.eowp.product.firstMonth ? '' : 'disabled';
        },
        todaysDate() {
            return this.formatDate(new Date());
        },
        discountStartDate() {
            const today = new Date();
            var startDate = new Date(today);

            if(this.currentPurchaseStatus == this.purchaseStatuses.trial){ // Trialer
                startDate = new Date(this.eowp.nextBillingDate);
            }
            else if (this.currentPurchaseStatus == this.purchaseStatuses.upgrade){ //Upgrader
                startDate = new Date(this.eowp.subscriptionInfo.currentPeriodEnd);
            }
            // Default case: Repurchaser
            return this.formatDate(startDate);
        },
        discountEndDate() {
            const endDate = new Date(this.discountStartDate);
            let durationInMonths = this.duration == 'once' ? 1 : this.durationInMonths;

            if (this.currentPurchaseStatus == this.purchaseStatuses.upgrade && this.couponId == ''){
                endDate.setFullYear(endDate.getFullYear() + 1);
            }
            else {
                if(this.eowp.product.itemId == '9111620'){
                    endDate.setMonth(endDate.getMonth() + durationInMonths);
                }
                else if(this.eowp.product.itemId == '9111621'){
                    endDate.setMonth(endDate.getMonth() + 12);
                }
            }

            return this.formatDate(endDate);
        },
        startDatePlusOneMonth() {
            const startDate = new Date(this.discountStartDate);
            startDate.setMonth(startDate.getMonth() + 1);
            return this.formatDate(startDate);
        }
    },
    methods: {
        ...mapActions({
            dateExpired: 'ncs/dateExpired',
            retrieveProduct: 'ncs/retrieveProduct',
            retrieveProducts: 'ncs/retrieveProducts',
            retrieveOtherSubscription: 'ncs/retrieveOtherSubscription',
            getCurrentSubscription: 'ncs/getCurrentSubscription',
            getPreviousItemSubscriptions: 'ncs/getPreviousItemSubscriptions',
            countPreviousItemSubscriptions: 'ncs/countPreviousItemSubscriptions',
            getActiveFreeMonthRecords: 'ncs/getActiveFreeMonth',
            setPathIntention: 'user/setPathIntention',
            checkSession: 'user/checkSession',
            logActivity: 'log/logActivity',
            setCancelPurchase: 'user/setCancelPurchase',
            trackOutboundClickEvent: 'ga/trackOutboundClickEvent',
            trackClickEvent: 'ga/trackClickEvent',
            setItemCharge: 'pg/setItemCharge',
            setFreeMonth: 'pg/setFreeMonth',
            setReadAgreement: 'pg/setReadAgreement',
            clearReadAgreement: 'pg/clearReadAgreement',
            clearChangeCC: 'pg/setUpdateCC',
            clearUpdateCCResult: 'pg/clearUpdateCCResult',
            getInfo: 'info/getInfo',
            checkEligibilityAndGetPriceAfterCouponPromo: 'coupon/checkEligibilityAndGetPriceAfterCouponPromo',
            applyCoupon: 'coupon/applyCoupon',
            savePromoCode: 'coupon/savePromoCode',
            clearPromoCode: 'coupon/clearPromoCode',
            clearCouponId: 'coupon/clearCouponId',
            getSubscriptionInfo: 'ssr/getSubscriptionInfo',
            setPaymentSuccessFlag: 'pg/setSuccessFlag',

            // saveCouponId: 'coupon/saveCouponId', //used for testing, for offer page
        }),
        disableElement(flag) {
            let clazz = flag + '-disabled';
            return  !this.readAgreement ? clazz : '';
        },
        disablePromoCodeButton(flag) {
            let clazz = flag + '-disabled';
            return this.promoCodeButtonDisabled ? clazz : flag;
        },
        validateInput() {
            if (this.inputValue && !this.pageLoadingIndicator) { // if any input is provided and page is not still loading, enable button
                this.promotionErrorMessage = '';
                this.promoCodeWarningMessage = '';
                this.promoCodeButtonDisabled = false;
                this.promotionApplied = false;
                if (this.inputValue.length > 100) {
                    this.inputValue = this.inputValue.slice(0,100);
                }
                if (!this.promotionApplied){
                    this.showPromoCodeWarning();
                }
                //Handle zenkaku characters
                this.inputValue = this.inputValue.replace(/[\uFF01-\uFF5E]/g, (ch) => {
                    return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
                }).replace(/[\u3000]/g, ' ');
            } else {
                //default case, on page load. Input is empty, so button is disabled
                this.promoCodeButtonDisabled = true;
                this.promoCodeWarningMessage = '';
                this.promotionErrorMessage = '';
            }
        },
        parsePromoCodeResponse(new_base_price, new_merchant_price, tax, duration, duration_in_months){
            this.oldTax = this.eowp.product.tax;
            this.oldBasePrice = this.eowp.product.firstMonth ? 0 : this.eowp.product.basePrice;
            this.oldTotalPrice = this.eowp.product.firstMonth ? 0 : this.eowp.product.totalPrice;
            this.oldMerchantPrice = this.eowp.product.merchantPrice;

            this.newTax = tax;
            this.newBasePrice = new_base_price;
            this.newTotalPrice = new_base_price + tax;
            this.newMerchantPrice = new_merchant_price;

            this.eowp.product.basePrice = this.eowp.product.firstMonth ? 0 : (this.newBasePrice); //if free trial, 0 else newbase
            this.eowp.product.totalPrice = this.eowp.product.firstMonth ? 0 : (this.newTotalPrice); //if free trial, 0 else newbase
            this.eowp.product.merchantPrice = this.newMerchantPrice;
            this.eowp.product.tax = tax;

            this.duration = duration;
            this.durationInMonths = duration_in_months;

            this.promotionApplied = true;
            this.promoCodeButtonDisabled = true;
        },
        //TODO: Refactor into 2 methods: 1 which assemble to request parameters, 2 to make the request (and do very little else)
        async applyPromotion() {
            this.loadingIndicator = true;
            this.promoCodeButtonDisabled = true;
            this.promoCodeWarningMessage = '';
            this.promotionErrorMessage = '';
            if (this.$refs.promoCode?.value || this.savedPromoCode != '' || this.savedCouponId != '') { 
                var couponSource = '';
                if (this.$refs.promoCode?.value) {
                    const promoCode = this.$refs.promoCode;
                    this.promoCode = promoCode.value;
                    couponSource = 'promo-ref';
                }
                else if(this.savedPromoCode != ''){
                    this.promoCode = this.savedPromoCode;
                    couponSource = 'promo-vuex';
                }
                else if(this.savedCouponId != ''){
                    this.couponId = this.savedCouponId;
                    couponSource = 'coupon-vuex';
                }
                let sessionId = this.paymentParams.sessionId;
                await this.checkSession(sessionId).then(isActive => {
                    if (isActive) {
                        this.logActivity({
                            type: "info", message: " Submitted promoCode:" + this.promoCode + " with userId: " + this.sessionDetails.userId + ", sessionId: " + this.sessionDetails.sessionId
                                + ", totalPrice: " + this.eowp.product.totalPrice + " and itemId: " + this.eowp.product.itemId
                        });
                    } else {
                        console.warn("Basket page failed to find an active session");
                    }
                });
                const userId = this.sessionDetails.userId;
                const csMatno = this.eowp.product.itemId;
                const basePrice = this.eowp.product.firstMonth ? 0 : (this.eowp.product.basePrice);
                const totalPrice = this.eowp.product.totalPrice;
                const merchantPrice = this.eowp.product.merchantPrice;
                
                const couponManager = new CouponManager(this);
                    const response = await couponManager.checkEligibilityAndGetPriceAfterCouponPromo(userId, csMatno, this.promoCode, this.couponId, basePrice, totalPrice, merchantPrice, this.eowp.product.firstMonth);
                    if(response.status_code == 200){ //Checks for a 200 response from the checkEligibilityAndGetPriceAfterCouponPromo call
                        if(response.data.valid == false || response.data.eligible == false){
                            if(couponSource == 'promo-vuex'){
                                this.clearPromoCode(); // After getting an invalid or ineligible promoCode from the state, clear it, then do nothing else with the response (keep showing defaultBasket)
                            }
                            else if(couponSource == 'coupon-vuex'){
                                this.clearCouponId(); // After getting an invalid or ineligible promoCode from the state, clear it, then do nothing else with the response (keep showing defaultBasket)
                                this.couponId = '';
                            }
                            else{
                                this.promotionErrorMessage = this.getReasonCodeMessage(response.data.reason_code, response.data);
                            }
                        }
                        else{
                            this.savePromoCode(this.promoCode);
                            this.promotionErrorMessage = ''
                            if(response.data.amount_off){
                                this.discount = response.data.amount_off + "円";
                            }
                            else if(response.data.percent_off){
                                this.discount = response.data.percent_off + "%";
                            }
                            this.parsePromoCodeResponse(
                                response.data.new_base_price, 
                                response.data.new_merchant_price, 
                                response.data.tax, 
                                response.data.duration, 
                                response.data.duration_in_months
                            );
                            this.showPromotionSuccess();
                        }
                    }
                    else { //if not 200 (meaning 400 or 500) from checkEligibilityAndGetPriceAfterCouponPromo call
                        if (this.couponId != '') {
                            this.paramError = 6;
                            return;
                        }
                        this.promotionErrorMessage = '通信障害により処理の完了を確認できませんでした。<br />恐れ入りますが、再度お試しください。<br />解決しない場合はお手数ですが、<a target="_blank" href="' + ShopConstants.CONTACT_FORM_LINK + '">英辞郎 on the WEB お問い合わせフォーム</a>からお問い合わせください。';
                    }
            } else {
                this.promoCodeButtonDisabled = false;
            }
            this.pageLoadingIndicator = false; //Show page content upon initial load now that the coupon is ready
            this.loadingIndicator = false;
        },
        applyPromotionOnEnter(event) {
            var x = event.code;
            if(x == 'Enter' & !this.promoCodeButtonDisabled) {
                this.applyPromotion();
            }    
        },
        getReasonCodeMessage(reasonCode, data = {}) {
            if (!Object.prototype.hasOwnProperty.call(this.reasonInfo, reasonCode)) {
                return "不明なエラーです。";
            }
            let message = this.reasonInfo[reasonCode];
            // Replace placeholders with data values
            for (const key in data) {
                let value = data[key];
                // Check if the key is 'eligible_course' and apply mapping
                if (key === 'eligible_courses') {
                    let courseList = Array.isArray(value)
                        ? value
                        : String(value).split(',').map(id => id.trim());
                    value = courseList
                        .map(courseId => ShopConstants.COURSE_MAPPING[courseId] || courseId)
                        .join(', ');
                }
                    else if (key == 'minimum_amount' && value != null){
                        value = this.formatPrice(value);
                    }
                const placeholder = `{${key}}`;
                message = message.replace(placeholder, value);
            }
            return message;
        },
        showPromoCodeWarning() {
            this.promoCodeWarningMessage = "「使用する」を押してください。";

        },
        showPromotionSuccess() {
            var discountName = '';
            if(this.savedCouponId != ''){
                discountName = this.savedCouponId; //Assign the discountName to the couponId, so users can be shown that they get the discount they saw on the Offer page (tentative Implementation #TODO Update this as needed)
            }
            else{
                discountName = this.promoCode; //Assign the discountName to the promoCode, so users can be shown that they get the discount of the promoCode they entered
            }
            this.promotionSuccessMessageTitle = this.couponId == '' ? "クーポンコード「" + discountName + "」が適用されました。" : "クーポンコードが適用されました。";
            if(this.eowp.product.itemId == '9111621'){
                // For yearly subscriptions, check if duration is forever
                if(this.duration == 'forever'){
                    this.promotionSuccessMessageText = "次回から年間のご利用料金が" + this.discount + "、割り引かれます（この割引は、今回のサブスクリプションを停止しない限り続きます）。";
                } else {
                    this.promotionSuccessMessageText = "次の１回の年間利用料金が" + this.discount + "、割り引かれます。";
                }
            }
            else if(this.duration == 'forever'){
                this.promotionSuccessMessageText = "次回から月間のご利用料金が" + this.discount + "、割り引かれます（この割引は、今回のサブスクリプションを停止しない限り続きます）。";
            }
            else if(this.durationInMonths == 1 || this.duration == 'once'){
                    this.promotionSuccessMessageText = "1カ月、利用料金が" + this.discount + "、割り引かれます。";
                }
            else{
                this.promotionSuccessMessageText = this.durationInMonths + "カ月連続で利用料金が" + this.discount + "、割り引かれます。";
            }
        },
        hidePromotionError(){
            this.promotionErrorMessage = '';
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}/${month}/${day}`;
        },
        restoreDefaultBasket(){
            this.clearPromoCode();
            this.eowp.product.tax = this.oldTax;
            this.eowp.product.basePrice = this.oldBasePrice;
            this.eowp.product.totalPrice = this.oldTotalPrice;
            this.eowp.product.merchantPrice = this.oldMerchantPrice;
            this.promotionErrorMessage = '';
            this.promotionSuccessMessageTitle = '';
            this.promotionSuccessMessageText = '';
            this.promoCodeWarningMessage = '';
            this.promoCodeButtonDisabled = true;
            this.promotionApplied = false;
            this.duration = 'once';
            this.inputValue = '';
        },
        async submitForm(eventName) {
            this.loadingIndicator = true;
            this.trackBasketPageEvents(eventName);

            try {
                const sessionIsValid = await this.validateSession();
                if (!sessionIsValid) {
                    this.$router.push('/signin');
                    return;
                }
                if (this.shouldApplyCouponToCurrentSubscription()) {
                    await this.applyCouponFlow();
                } else {
                    await this.paymentFlow();
                }

            } catch (error) {
                this.$router.push({
                        path: '/account',
                        query: { error: encodeURIComponent("default") }
                    });
                return;
            } finally {
                this.loadingIndicator = false;
            }
        },

        async validateSession() {
            const sessionActive = await this.checkActiveSession();
            if (!sessionActive) return false;

            const sessionId = this.paymentParams.sessionId;
            try {
                const isSessionValid = await this.checkSession(sessionId);
                return isSessionValid;
            } catch (error) {
                return false;
            }
        },

        shouldApplyCouponToCurrentSubscription() {
            return this.couponId &&
                this.currentSubscription &&
                this.currentSubscription.csMatNo === this.eowp.product.itemId &&
                !this.isSubscriptionExpired();
        },

        async applyCouponFlow() {
            try {
                const couponManager = new CouponManager(this);
                const response = await couponManager.applyCoupon(this.couponId, this.sessionDetails.userId);
                this.clearCouponId();

                if (response.status_code === 200) {
                    this.setPaymentSuccessFlag('1');
                    this.$router.push("/payment-success");
                } else {
                    this.$router.push({
                        path: '/account',
                        query: { error: encodeURIComponent(response.status_code) }
                    });
                    return;
                }

            } catch (error) {
                this.$router.push({
                    path: '/account',
                    query: { error: encodeURIComponent("default") }
                });
                return;
            }
        },

        async paymentFlow() {
            this.setFreeMonth(this.eowp.product.firstMonth);
            this.$router.push("/payment");

            this.logActivity({
                type: "info",
                message: `Submitted basket with userId: ${this.sessionDetails.userId}, sessionId: ${this.sessionDetails.sessionId}, totalPrice: ${this.eowp.product.totalPrice}, and itemId: ${this.eowp.product.itemId}`
            });
        },

        isEmpty(object){
            return Utils.isEmpty(object);
        },
        nextBillingUnit(){
            let unit = "";
            if (this.eowp.product.itemId){
                unit = ShopConstants.BILLING_MAPPING[this.eowp.product.itemId]
            }
            return unit;
        },
        backButtonClicked(){
            let itemCancelled = {
                id: this.eowp.product.itemId,
                name: this.eowp.product.name,
                price: this.eowp.product.basePrice,
                quantity: 1
            };
            this.setCancelPurchase(itemCancelled);
            let vm = this;
            setTimeout(() => {
                vm.$router.push("/products");
            }, 50);
        },
        trackBasketPageEvents(eventName){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
        },
        trackBasketPageHyperlinks(eventName, url){
            this.trackOutboundClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        },
        formatPrice(price){
            return Utils.formatNumber(price);
        },
        purchaseStatus(){
            // If no current subscription, user is in trial
            if (!this.currentSubscription) {
                return this.purchaseStatuses.trial;
            }
            // If current subscription is active (useStatus == '1')
            if (this.currentSubscription.useStatus === '1') {
                // If user is trying to purchase the same product, it's a upgrade (Coupon)
                if (this.currentSubscription.csMatNo === this.eowp.product.itemId) {
                    return this.purchaseStatuses.upgrade;
                }    
                // If user is trying to purchase a different product, it's an upgrade
                return this.purchaseStatuses.upgrade;
            }
            // For any other useStatus (0, 2, etc.), it's a repurchase
            return this.purchaseStatuses.repurchase;
        },
        
        isSubscriptionExpired() {
            if (!this.currentSubscription || !this.currentSubscription.validTo) {
                return false;
            }
            
            const now = new Date();
            const validTo = new Date(this.currentSubscription.validTo);
            const isExpired = validTo.getTime() <= now.getTime();
            
            return isExpired;
        },
    },
    components: {
        BAlert
    },
    mixins: [
        DialogMixin
    ]
};
</script>
